export default __webpack_public_path__ + "static/media/money.a943ba5e.svg";